import { useDispatch } from 'react-redux';

import { useOrderUpdate } from '../../../../Checkout/hooks';

import { ExareStatus } from '@websky/graphql';
import { clearExchangeVariants, clearPaymentStatus, setLoading, stopLoading, useExchange } from '@entities/exchange';
import { useRouter } from '@shared/lib/router';

export function useRefreshExchangeOrder() {
	const dispatch = useDispatch();

	const router = useRouter();

	const { onRefreshOrder } = useOrderUpdate();
	const { updateOrder } = useExchange();

	const onClearExchangeState = () => {
		dispatch(clearExchangeVariants());
		dispatch(clearPaymentStatus());
	};

	const onBackToOrder = async () => {
		await updateOrder();
		router.navigate('/order');
	};

	const onFinishExchangeOrder = async () => {
		onClearExchangeState();
		await onBackToOrder();
	};

	const onPollingOrder = async (interval: number) => {
		const order = await onRefreshOrder();
		const lastExchange = order?.Order?.exareInfo?.lastExchange;

		if (lastExchange?.status === ExareStatus.Finished) {
			await onFinishExchangeOrder();
		} else {
			setTimeout(() => onPollingOrder(interval * 1.5), interval * 1.5);
		}
	};

	const onRefreshExchangeOrder = async (failedExchange?: boolean) => {
		dispatch(setLoading('all'));

		const order = await onRefreshOrder();
		const lastExchange = order?.Order?.exareInfo?.lastExchange;

		if (failedExchange) {
			if (lastExchange) {
				onClearExchangeState();
			} else {
				await onBackToOrder();
			}
		} else if (lastExchange && lastExchange.status === ExareStatus.Finished) {
			await onFinishExchangeOrder();
		} else {
			setTimeout(() => onPollingOrder(500), 500);
		}

		dispatch(stopLoading());
	};

	return {
		onRefreshOrder,
		onRefreshExchangeOrder
	};
}
